import React from 'react';
import TodoList from './Components/Todo'

function App() {
  return (
    <div className="App">
      <TodoList />
    </div>
  );
}

export default App;
